import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import moment from "moment";

const months = [
  { label: "Month", value: "" },
  { label: "January", value: "01" },
  { label: "February", value: "02" },
  { label: "March", value: "03" },
  { label: "April", value: "04" },
  { label: "May", value: "05" },
  { label: "June", value: "06" },
  { label: "July", value: "07" },
  { label: "August", value: "08" },
  { label: "September", value: "09" },
  { label: "October", value: "10" },
  { label: "November", value: "11" },
  { label: "December", value: "12" },
];

const CustomDatePicker = ({ question, cIndex, CommunityArr, setCommunityArr, onValidationChange }) => {
  const existingDate = question?.answer?.[0]?.answer?.[0];
  const formattedDate = existingDate && existingDate !== "INVALID_DATE"
    ? moment(existingDate, "MM/DD/YYYY", true)
    : null;

  // ✅ store input values in component state
  const [month, setMonth] = useState(formattedDate ? formattedDate.format("MM") : "");
  const [day, setDay] = useState(formattedDate ? formattedDate.format("DD") : "");
  const [year, setYear] = useState(formattedDate ? formattedDate.format("YYYY") : "");
  const [error, setError] = useState(false);

  useEffect(() => {
    // When data loads from backend, sync local inputs
    if (existingDate && existingDate !== "INVALID_DATE") {
      const m = moment(existingDate, "MM/DD/YYYY", true);
      if (m.isValid()) {
        setMonth(m.format("MM"));
        setDay(m.format("DD"));
        setYear(m.format("YYYY"));
        setError(false);
      }
    }
  }, [existingDate]);

  const updateDate = (newMonth, newDay, newYear) => {
    const updated = [...CommunityArr];
    const list = updated[cIndex][question.source];
    const idx = list.findIndex((q) => q._id === question._id);

    if (idx === -1) return;

    // If incomplete, clear
    if (!newMonth || !newDay || !newYear) {
      list[idx].answer = [];
      list[idx].invalidDate = false;
      setError(false);
      setCommunityArr(updated);
      return;
    }

    const formatted = `${newMonth.padStart(2, "0")}/${newDay.padStart(2, "0")}/${newYear}`;
    const m = moment(formatted, "MM/DD/YYYY", true);

    if (!m.isValid()) {
      list[idx].answer = [{ answer: ["INVALID_DATE"] }];
      list[idx].invalidDate = true;
      setError(true);
      onValidationChange?.(true);
    } else {
      list[idx].answer = [{ answer: [formatted] }];
      list[idx].invalidDate = false;
      setError(false);
      onValidationChange?.(false);
    }

    setCommunityArr(updated);
  };

  return (
    <div className="dob-splitter">
      {/* Month Dropdown */}
      <div className="splitter-itm">
        <div className="form-input">
          <Form.Select
            aria-label="Month"
            value={month}
            onChange={(e) => {
              const newVal = e.target.value;
              setMonth(newVal);
              updateDate(newVal, day, year);
            }}
          >
            {months.map((m) => (
              <option key={m.value} value={m.value}>
                {m.label}
              </option>
            ))}
          </Form.Select>
        </div>
      </div>

      {/* Day Input */}
      <div className="splitter-itm">
        <div className="form-input">
          <input
            type="number"
            placeholder="Day"
            className="form-control"
            value={day}
            onChange={(e) => {
              let val = e.target.value;
              if (val === "") {
                setDay("");
                updateDate(month, "", year);
              } else {
                val = Math.min(Math.max(parseInt(val), 1), 31);
                setDay(val.toString());
                updateDate(month, val.toString(), year);
              }
            }}
            onKeyDown={(e) => {
              if (e.key === "0" && e.target.value === "") e.preventDefault();
            }}
            min="1"
            max="31"
          />
        </div>
      </div>

      {/* Year Input */}
      <div className="splitter-itm">
        <div className="form-input">
          <input
            type="number"
            placeholder="Year"
            className="form-control"
            value={year}
            onChange={(e) => {
              const val = e.target.value;
              setYear(val);
              updateDate(month, day, val);
            }}
            onBlur={(e) => {
              const val = parseInt(e.target.value);
              if (!val) return;
              const clamped = Math.min(Math.max(val, 1900), new Date().getFullYear());
              setYear(clamped.toString());
              updateDate(month, day, clamped.toString());
            }}
            min="1900"
            max={new Date().getFullYear()}
          />
        </div>
      </div>

      
    </div>
  );
};

export default CustomDatePicker;
